
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { Star, Pin, Lightbulb } from "lucide-react";
import { Database } from "@/integrations/supabase/types";

type EntryInsert = Database["public"]["Tables"]["entries"]["Insert"];

interface EntryStatusCardProps {
  entry: EntryInsert & { is_pinned?: boolean };
  isAdmin: boolean;
  onFieldChange: (field: string, value: any) => void;
}

export const EntryStatusCard: React.FC<EntryStatusCardProps> = ({
  entry,
  isAdmin,
  onFieldChange
}) => {
  return (
    <Card>
      <CardContent className="pt-6">
        <h3 className="text-lg font-medium mb-4">Entry Status</h3>
        <div className="space-y-4">
          <div className="flex items-center space-x-2">
            <Checkbox 
              id="public" 
              checked={entry.is_public || false}
              onCheckedChange={(checked) => 
                onFieldChange("is_public", checked === true)
              }
            />
            <Label htmlFor="public" className="flex items-center">
              Make Public
            </Label>
          </div>
          
          <div className="flex items-center space-x-2">
            <Checkbox 
              id="favorite" 
              checked={entry.is_favorite || false}
              onCheckedChange={(checked) => 
                onFieldChange("is_favorite", checked === true)
              }
            />
            <Label htmlFor="favorite" className="flex items-center">
              <Star className="h-4 w-4 mr-2" />
              Add to Favorites
            </Label>
          </div>

          <div className="flex items-center space-x-2">
            <Checkbox 
              id="pinned" 
              checked={entry.is_pinned || false}
              onCheckedChange={(checked) => 
                onFieldChange("is_pinned", checked === true)
              }
            />
            <Label htmlFor="pinned" className="flex items-center">
              <Pin className="h-4 w-4 mr-2" />
              Pin to Dashboard
            </Label>
          </div>

          {isAdmin && (
            <div className="flex items-center space-x-2">
              <Checkbox 
                id="postscript" 
                checked={entry.is_postscript || false}
                onCheckedChange={(checked) => 
                  onFieldChange("is_postscript", checked === true)
                }
              />
              <Label htmlFor="postscript" className="flex items-center">
                <Lightbulb className="h-4 w-4 mr-2" />
                Add to Postscript
              </Label>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
